import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import grid_state_helpers, {GridState, initialGridState} from "../../../libs/grid_state_reducers";
import {Tables} from "../../../apitypes";
import {RegFilters} from "../registrations/reg_grid_slice";

const startDate = new Date()
startDate.setHours(0, 0, 0);
const initialState: GridState & RegFilters = {
    ...initialGridState,
    sort: [{field: "StartTime", sort: "desc"}],
    ftx: "",
    startTime: startDate.toISOString(),
    endTime: null,
    product: [],
    partner: [],
    operation: [],
    machine: [],
    worker: [],
    workOrder: [],
    user: [],
};

const slice = createSlice({
    name: "regbyworker",
    initialState,
    reducers: {
        ...grid_state_helpers,
        setOperation: (state, action: PayloadAction<Tables<"workTask">[]>) => {
            state.operation = action.payload
        },
        setWorker: (state, action: PayloadAction<Tables<"worker">[]>) => {
            state.worker = action.payload
        },
        setWorkOrder: (state, action: PayloadAction<Tables<"workOrder">[]>) => {
            state.workOrder = action.payload
        },
        setPartner: (state, action: PayloadAction<Tables<"partner">[]>) => {
            state.partner = action.payload
        },
        setUser: (state, action: PayloadAction<Tables<"profile">[]>) => {
            state.user = action.payload
        },
        setMachine: (state, action: PayloadAction<Tables<"machine">[]>) => {
            state.machine = action.payload
        },
        setProduct: (state, action: PayloadAction<Tables<"product">[]>) => {
            state.product = action.payload
        },
        setStartTime: (state, action: PayloadAction<string | null>) => {
            state.startTime = action.payload
        },
        setEndTime: (state, action: PayloadAction<string | null>) => {
            state.endTime = action.payload
        },
        resetSearch: (state) => {
            return {...initialState, columns: state.columns, seq: state.seq + 1}
        }
    }
});

export const {
    setFilter,
    setSort,
    setPaginationModel,
    setOperation,
    setPartner,
    setProduct,
    setWorkOrder,
    setMachine,
    setUser,
    setWorker,
    resetSearch,
    setColumns,
    setStartTime,
    setEndTime,
} = slice.actions
export const reducer = slice.reducer;
